export default {
  menu: {
    home: "工作台",
    system: "系统管理",
    systemUser: "用户管理",
    systemUserAdd: "用户新增",
    systemRole: "角色管理",
    systemRoleAdd: "角色管理",
    systemDepartment: "部门管理",
    systemDepartmentAdd: "部门管理",
    systemPost: "岗位管理",
    systemPostAdd: "岗位管理",
    systemMenu: "菜单管理",
    systemMenuAdd: "菜单新增",
    systemMenuEdit: "菜单编辑",
    systemMenuRemove: "菜单删除",
    product: "库存管理",
    productStock: "仓库库存",
    productOffice: "办公区库存",
    order: "订单管理",
    orderPredict: "预测单",
    orderSale: "销售单",
    orderPurchase: "采购单",
    orderStockInput: "入库单",
    orderStockInputAdd: "新增入库单",
    orderStockInputEdit: "编辑入库单",
    orderStockOut: "出库单",
    orderStockOutAdd: "新增出库单",
    orderStockOutEdit: "编辑出库单",
    review: "审核管理",
    reviewProcess: "审核流程",
    reviewPredict: "预测单审核",
    reviewStockOut: "出库单审核",
    reviewPurchase: "采购单审核",
    log: "日志记录",
    logLogin: "登录日志",
    logBehavior: "操作日志",
    orderPredictLog: "预测记录",
    orderPurchaseLog: "采购记录",
    orderSaleLog: "销售记录",
    analysis: "统计分析",
    demo: "示例",
    demoPage: "页面",
    demoIcon: "图标",
    demoIconIfy: "Iconify",
    demoAnimaCss: "动画",
    demoXlsx: "Xlsx",
    demoMap: "CV拖拽缩放",
    demoMapOne: "CV分割地图",
    demoMapTwo: "CV拖拽",
    demoBrowser: "浏览器信息",
    demoEchart: "图表Echart",
    demoSwiper: "幻灯片Swiper",
    demoWifi: "Wifi-Card",
    demoTimeSelect: "时间轴",
    demoLottery: "抽奖",
    demoActivity: "工作流",
    demoImg: "图片格式转换",
    demoThree: "ThreeJS",
    demoPdf: "PDF",
    demoDraggable: " 拖拽",
    testLink: "链接",
    testIframe: "Iframe",
  },
  title: {
    home: "工作台",
    login: "登录",
    register: "注册",
    auth: "授权",
    noPower: "无权限",
    notFound: "未找到页面",
    serverError: "服务错误",
  },
  msg: {
    copy: "复制成功",
  },
  dateTime: {
    week: "近一周",
    month: "近一个月",
    monthThree: "近三个月",
  },
};
